module.exports = __webpack_public_path__ + "static/a7-1c1cc71a0136a89cf2135e6e4503afd3.svg";